import axios from "axios";
import store from "../stores/store";

const basePath = `${process.env.REACT_APP_API_BASE_URL}/store`;

const simulatePurchase = async (payload) => {
	try {
		const formData = new FormData();

		// Adiciona os produtos ao FormData
		payload.products.forEach((product, index) => {
			formData.append(`products[${index}][catalog_id]`, product.catalog_id);
			formData.append(`products[${index}][quantity]`, product.quantity);
		});

		// Adiciona os outros campos ao FormData
		formData.append("ladder", payload.ladder);
		formData.append("disassemble", payload.disassemble);
		formData.append("promotional_code", payload.promotional_code);

		let authToken = "";
		const token = store.getState().auth.token;

		if (token) {
			authToken = `Bearer ${token}`;
		}

		const apiUrl = `${basePath}/purchase/simulate`;

		const response = await axios.post(apiUrl, formData, {
			headers: {
				"Content-Type": "multipart/form-data",
				Authorization: authToken,
			},
		});

		return response.data;
	} catch (error) {
		if (error.response && error.response.status === 400) {
			// Se erro 400, exibe a mensagem do erro
			return error.response.data;
		} else {
			console.error(
				"purchaseService.simulatePurchase",
				"Error get purchase",
				error
			);
			return null;
		}
	}
};

const purchase = async (payload) => {
	const formData = new FormData();

	formData.append("period_id", payload.period_id);
	formData.append("residence_type_id", payload.residence_type_id);
	formData.append("first_name", payload.first_name);
	formData.append("last_name", payload.last_name);
	formData.append("cpf", payload.cpf?.replace(/\D/g, ""));
	formData.append("telephone", "+55" + payload.telephone?.replace(/\D/g, ""));
	formData.append("email", payload.email);
	formData.append("zip_code", payload.zip_code);
	formData.append("street", payload.street);
	formData.append("neighborhood", payload.neigh);
	formData.append("state", payload.state);
	formData.append("city", payload.city);
	formData.append("number", payload.number);
	formData.append("complement", payload.complement);
	formData.append("reference", payload.reference);
	formData.append("responsible", payload.responsible);
	formData.append("observation", payload.observation);
	formData.append("schedule_request_date", new Date(payload.schedule_request_date));
	formData.append("ladder", payload.ladder);
	formData.append("disassemble", payload.disassemble);
	formData.append("promotional_code", payload.promotional_code);

	payload.products.forEach((product, index) => {
		formData.append(`products[${index}][catalog_id]`, product.catalog_id);
		formData.append(`products[${index}][quantity]`, product.quantity);
	});

	try {
		const apiUrl = `${basePath}/purchase`;

		let authToken = "";
		const token = store.getState().auth.token;

		if (token) {
			authToken = `Bearer ${token}`;
		}

		const response = await axios.post(apiUrl, formData, {
			headers: {
				"Content-Type": "multipart/form-data",
				Authorization: authToken,
			},
		});
		return response.data;
	} catch (error) {
		if (error.response && error.response.status === 400) {
			// Se erro 400, exibe a mensagem do erro
			return error.response.data;
		} else {
			if (error?.response?.data?.message) {
				return error?.response?.data;
			}

			console.error("purchaseService.purchase", "Error post purchase", error);
			return null;
		}
	}
};

const payment = async (orderId, paymentMethod, payload) => {
	const formData = new FormData();
	const method = paymentMethod === "pix" ? 1 : 2;

	formData.append("payment_method", method);

	if (paymentMethod === "card") {
		formData.append("card[installments]", payload.installments);
		formData.append("card[number]", payload.cardNumber.trim().replace(/\D/g, ""));
		formData.append("card[document]", payload.cardDocHolder.replace(/\D/g, ""));
		formData.append("card[name]", payload.cardHolder);
		formData.append("card[cvv]", payload.cvv);
		formData.append("card[exp_month]", payload.expiryDate.split("/")[0].trim());
		formData.append("card[exp_year]", payload.expiryDate.split("/")[1].trim());
	}

	try {
		let authToken = "";
		const token = store.getState().auth.token;

		if (token) {
			authToken = `Bearer ${token}`;
		}

		const apiUrl = `${basePath}/service-order/${orderId}/pay`;

		const response = await axios.post(apiUrl, formData, {
			headers: {
				"Content-Type": "multipart/form-data",
				Authorization: authToken,
			},
		});

		return response.data;
	} catch (error) {
		if (error.response && error.response.status === 400) {
			// Se erro 400, exibe a mensagem do erro
			return error.response.data;
		} else {
			if (error?.response?.data?.message) {
				return error?.response?.data;
			}

			console.error("purchaseService.payment", "Error post payment", error);
			return null;
		}
	}
};

export const purchaseService = {
	simulatePurchase,
	purchase,
	payment,
};
